import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { secureBaseQuery } from './secureBaseQuery.js'
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";


export const templateApi = createApi({
  reducerPath: 'templateApi',
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken')
      if (token) {
        headers.set("Authorization", `Bearer ${token}`)
      }
      return headers
    },
  }),
      //  baseQuery: dynamicBaseQuery,

  tagTypes: ["Template"],

  endpoints: (builder) => ({
    createTemplate: builder.mutation({
      query: (data) => ({
        url: '/template/templates',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ["Template"],
    }),

    getTemplateByPrincipalId: builder.query({
      query: (id) => ({
        url: `/template/templates/${id}`,
        method: 'GET',
      }),
      providesTags: ["Template"],
    }),

    updateTemplate: builder.mutation({
      query: (data) => ({
        url: `/template/templates`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ["Template"],
    }),

    deleteTemplate: builder.mutation({
      query: (templateId) => ({
        url: `/template/templates/${templateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ["Template"],
    }),
  }),
})

export const {
  useDeleteTemplateMutation,
  useGetTemplateByPrincipalIdQuery,
  useUpdateTemplateMutation,
  useCreateTemplateMutation,
} = templateApi
